import EbikeIcons from '@/js/components/Shared/IconSelect/Icons/Specs/Ebike/'
import GroupIcons from '@/js/components/Shared/IconSelect/Icons/Specs/Groups/'
import ItemIcons from '@/js/components/Shared/IconSelect/Icons/Specs/Item/'
import ProductIcons from '@/js/components/Shared/IconSelect/Icons/Specs/Product/'

export default {
  ...EbikeIcons,
  ...GroupIcons,
  ...ItemIcons,
  ...ProductIcons,
}
